
import {
    View
} from "react-native";
import {
    type StateCardProps
} from "./types";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    NCoreUIKitLocalize,
    Text,
    Button
} from "ncore-ui-kit";
import {
    useNavigation
} from "@react-navigation/native";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import type RootStackParamList from "../../types/navigation";
import {
    LockKeyhole
} from "lucide-react-native";

const StateCard = ({
    title,
    description,
    buttonTitle,
    onPress
}: StateCardProps) => {
    const {
        colors,
        spaces,
        radiuses
    } = NCoreUIKitTheme.useContext();
    const {
        localize
    } = NCoreUIKitLocalize.useContext();
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

    return  <View
        style={[
            stylesheet.container,
            {
                padding: spaces.spacingXl
            }
        ]}
    >
        <View
            style={[
                stylesheet.iconContainer,
                {
                    backgroundColor: colors.content.container.primary,
                    padding: spaces.spacingXl,
                    borderRadius: radiuses.full,
                    marginBottom: spaces.spacingLg
                }
            ]}
        >
            <LockKeyhole
                color={colors.content.icon.mid}
                size={48}
            />
        </View>
        <Text
            variant="titleMediumSize"
            color="emphasized"
            style={[
                stylesheet.title,
                {
                    marginBottom: spaces.spacingMd
                }
            ]}
        >
            {title || localize("restricted-view-title")}
        </Text>
        <Text
            variant="bodyMediumSize"
            color="mid"
            style={[
                stylesheet.description,
                {
                    marginBottom: spaces.spacingXl
                }
            ]}
        >
            {description || localize("restricted-view-desc")}
        </Text>
        <Button
            title={buttonTitle || localize("login")}
            onPress={() => {
                if (onPress) {
                    onPress();
                } else {
                    navigation.navigate("Auth", {
                        screen: "Login"
                    });
                }
            }}
            spreadBehaviour="stretch"
        />
    </View>;
};

export default StateCard;
